module.exports = __webpack_public_path__ + "static/sf_6.808588bb.png";